import { Link } from "react-router-dom";
import { getLatestNews, formatDate } from "@/lib/content";

export default function LatestNews() {
  const news = getLatestNews(6);
  const lead = news[0];
  const rest = news.slice(1, 6);

  if (!lead) return null;

  return (
    <section className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <div className="mb-7 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-semibold tracking-[0.2em] text-accent-600">NEWSROOM</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            最新影视资讯
          </h2>
        </div>
        <Link
          to="/news"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 transition-colors hover:text-primary-800"
        >
          进入资讯专题
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Link
          to={`/news?id=${lead.id}`}
          className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
        >
          <div className="h-56 w-full overflow-hidden bg-background-200 md:h-72">
            <img
              src={lead.image}
              alt={lead.title}
              title={`${lead.title} 影视资讯配图`}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="flex flex-1 flex-col p-5 md:p-6">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-semibold text-accent-800">
                {lead.category}
              </span>
              <span className="text-xs text-secondary-500">{formatDate(lead.date)}</span>
            </div>
            <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
              {lead.title}
            </h3>
            <p className="mt-2.5 line-clamp-3 text-sm leading-relaxed text-foreground-600">
              {lead.excerpt}
            </p>
          </div>
        </Link>

        <div className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {rest.map((item) => (
            <Link
              key={item.id}
              to={`/news?id=${item.id}`}
              className="group flex items-start gap-3 p-4 transition-colors hover:bg-background-100 md:p-5"
            >
              <span className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-primary-50 text-[11px] font-bold text-primary-700">
                <i className="ri-newspaper-line" />
              </span>
              <div className="min-w-0">
                <h4 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h4>
                <p className="mt-1.5 flex flex-wrap items-center gap-2 text-xs text-secondary-500">
                  <span>{item.category}</span>
                  <span>·</span>
                  <span>{formatDate(item.date)}</span>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}